<template>
  <div>
    <header-component></header-component>

    <miles-and-chart-component></miles-and-chart-component>

    <transaction-history-component :showOptions = "true"></transaction-history-component>

    <footer-component></footer-component>
  </div>
</template>

<script>
import HeaderComponent from "./HeaderComponent.vue";
import TransactionHistoryComponent from "./TransactionHistoryComponent.vue";
import CategoryOffersComponent from "./CategoryOffersComponent.vue";
import FooterComponent from "./FooterComponent.vue";
import FaqsComponent from "./static/FaqsComponent.vue";
import MilesAndChartComponent from './MilesAndChartComponent.vue';

export default {
  components: {
    HeaderComponent,
    TransactionHistoryComponent,
    CategoryOffersComponent,
    FooterComponent,
    FaqsComponent,
    MilesAndChartComponent,
  },
  name: "MyAccountComponent",

  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
</style>
